<template>
  <div class="apply">
    <table-temp
      title
      :flag="1"
      :tableData="tableData"
      :columnData="tableConf"
      @editTable="editTable"
      :isEdit=false
      text="详情"
    >
      <template slot="other">
        <el-table-column label="申请状态" width="300">
          <template slot-scope="scope">
            <el-tag :type="dataMap[scope.row.checkState][0]">{{dataMap[scope.row.checkState][1]}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="审核意见" width="100">
          <template slot-scope="scope">
            <el-button
              v-if="[4,0].includes(scope.row.checkState)"
              @click="viewOption(scope.row)"
              type="text"
              size="small"
            >查看</el-button>
            <span v-else>--</span>
          </template>
        </el-table-column>
      </template>
    </table-temp>
    <view-dialog :dialogVisible="viewVisible" @closeDialog="closeDialog" :text="resText"></view-dialog>
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[5, 10, 20]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import TableTemp from "@table/table1";
import { applyConf } from "@/conf/Audit";
import ViewDialog from "./dialog/viewRes";
import { checkRecord } from "common/js/api";

const map = {
  0: ["warning", "未提交"],
  1: ["success", "待审核"],
  2: ["info", "审核中"],
  3: ["success", "审核通过"],
  4: ["danger", "已驳回"]
};

export default {
  components: {
    TableTemp,
    ViewDialog
  },

  data() {
    return {
      tableData: [],
      tableConf: applyConf,
      viewVisible: false,
      resText: "",
      dataMap: map,
      currentPage: 1,
      pageSize: 5,
      total: 0,
      userCode: this.Cookies.get("identifyCode")
    };
  },

  mounted() {
    this.getList();
  },

  methods: {
    async getList() {
      let params = {
        checkType: 1,
        page: this.currentPage,
        size: this.pageSize,
        userInstitutionCode: this.userCode
      };
      const res = await checkRecord(params);
    
      this.tableData = res.result.list;
      this.total = res.result.total;
      this.currentPage = res.result.pageNum;
      this.pageSize = res.result.pageSize;

    },

    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.getList();
    },

    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },

    editTable(data) {
     
      const flag = data.scope.row.institutionCode.slice(0, 2);
      const path =
        flag == "GL" ? "/Audit/FundManagerDetail" : "/Audit/FundDetail";
      this.$router.push({
        path,
        query: {
          institutionCode: data.scope.row.institutionCode
        }
      });
    },

    // anyDoRow(data) {
    //   console.log("TCL: anyDoRow -> data", data);
    //   const type = data.item.typeField.split("/")[1];
    //   const $index = data.scope.$index;
    //   if (type == "dialog") {
    //     this.resText = this.tableData[$index].resText;
    //     this.viewVisible = true;
    //   }
    // },

    viewOption(row) {
      this.resText = row.checkFeedback || "暂无审核意见";
      this.viewVisible = true;
    },

    closeDialog() {
      this.viewVisible = false;
    }
  }
};
</script>

